module.exports = __webpack_public_path__ + "media/images/custom_page/younite_event2/younite-event-th-870a6ab51e40e18019c6ed876626728b.png";